// Import utilities
import { onReady } from '@automator/utilities';

// Load global assets
import '@pages/global';

// Page "Dashboard"
import Dashboard from '@pages/dashboard';

// Page "Integrations"
import Integrations from '@pages/integrations';

// Page "Settings"
import Settings from '@pages/settings';

// Page "Logs"
import '@pages/logs';

// Page "Upgrade"
import '@pages/upgrade';

// Invoke classes when the DOM is ready
onReady( () => {
	new Dashboard();
	new Integrations();
	new Settings();
} );
